const types = {
	//Get Template name
	GET_PRIVATEDOCUMENT_START: "GET_PRIVATEDOCUMENT_START",
	GET_PRIVATEDOCUMENT_SUCCESS: "GET_PRIVATEDOCUMENT_SUCCESS",
	GET_PRIVATEDOCUMENT_ERROR: "GET_PRIVATEDOCUMENT_ERROR",
	GET_PRIVATEDOCUMENT_RESET: "GET_PRIVATEDOCUMENT_RESET",

	//Create Template name
	CREATE_PRIVATEDOCUMENT_START: "CREATE_PRIVATEDOCUMENT_START",
	CREATE_PRIVATEDOCUMENT_SUCCESS: "CREATE_PRIVATEDOCUMENT_SUCCESS",
	CREATE_PRIVATEDOCUMENT_ERROR: "CREATE_PRIVATEDOCUMENT_ERROR",
	CREATE_PRIVATEDOCUMENT_RESET: "CREATE_PRIVATEDOCUMENT_RESET",

	//delete Template name
	DELETE_PRIVATEDOCUMENT_START: "DELETE_PRIVATEDOCUMENT_START",
	DELETE_PRIVATEDOCUMENT_SUCCESS: "DELETE_PRIVATEDOCUMENT_SUCCESS",
	DELETE_PRIVATEDOCUMENT_ERROR: "DELETE_PRIVATEDOCUMENT_ERROR",
	DELETE_PRIVATEDOCUMENT_RESET: "DELETE_PRIVATEDOCUMENT_RESET",

	//update Template name
	UPDATE_PRIVATEDOCUMENT_START: "UPDATE_PRIVATEDOCUMENT_START",
	UPDATE_PRIVATEDOCUMENT_SUCCESS: "UPDATE_PRIVATEDOCUMENT_SUCCESS",
	UPDATE_PRIVATEDOCUMENT_ERROR: "UPDATE_PRIVATEDOCUMENT_ERROR",
	UPDATE_PRIVATEDOCUMENT_RESET: "UPDATE_PRIVATEDOCUMENT_RESET",

	//single item  name
	SINGLE_PRIVATEDOCUMENT_START: "SINGLE_PRIVATEDOCUMENT_START",
	SINGLE_PRIVATEDOCUMENT_SUCCESS: "SINGLE_PRIVATEDOCUMENT_SUCCESS",
	SINGLE_PRIVATEDOCUMENT_ERROR: "SINGLE_PRIVATEDOCUMENT_ERROR",
	SINGLE_PRIVATEDOCUMENT_RESET: "SINGLE_PRIVATEDOCUMENT_RESET",
};

export default types;
